import React, { useState, useEffect } from 'react';
import { colors, radius, fonts } from '../theme';
import { reservations, auth } from '../api';

export function LoyaltyPage({ user }: { user: any }) {
  const [transactions, setTransactions] = useState<any[]>([]);
  const [lastBill, setLastBill] = useState<any>(null);

  useEffect(() => {
    auth.loyalty().then(r => setTransactions(r.data)).catch(() => {});
    reservations.myLastBill().then(r => setLastBill(r.data)).catch(() => {});
  }, []);

  const reasons: Record<string, { emoji: string, label: string }> = {
    profile_completion: { emoji: '👤', label: 'Profil complété' },
    purchase: { emoji: '🛍️', label: 'Achat' },
    referral: { emoji: '🤝', label: 'Parrainage' },
    social_interaction: { emoji: '💬', label: 'Interaction sociale' },
    contest_win: { emoji: '🏆', label: 'Concours gagné' },
    best_ticket: { emoji: '⭐', label: 'Meilleur ticket' },
    event_organization: { emoji: '🎉', label: 'Organisation événement' },
  };

  const total = transactions.reduce((acc: number, t: any) => acc + t.points, 0);
  const level = total >= 1000 ? 'Or' : total >= 500 ? 'Argent' : total >= 100 ? 'Bronze' : 'Découverte';
  const levelColor = total >= 1000 ? colors.gold : total >= 500 ? '#C0C0C0' : total >= 100 ? '#CD7F32' : colors.textMuted;

  return (
    <div>
      <h2 style={{ color: colors.gold, fontSize: 24, marginBottom: 8 }}>Fidélité</h2>
      <p style={{ color: colors.textMuted, fontSize: 14, marginBottom: 24 }}>Vos points et récompenses</p>

      {/* Points Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        <div style={{ background: colors.card, borderRadius: radius.md, padding: 24, border: `1px solid ${colors.gold}40`, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 'bold', color: colors.gold }}>{user?.loyalty_points || 0}</div>
          <div style={{ color: colors.textMuted, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 }}>Points</div>
        </div>
        <div style={{ background: colors.card, borderRadius: radius.md, padding: 24, border: `1px solid ${colors.border}`, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 'bold', color: levelColor }}>{level}</div>
          <div style={{ color: colors.textMuted, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 }}>Niveau</div>
        </div>
        <div style={{ background: colors.card, borderRadius: radius.md, padding: 24, border: `1px solid ${colors.border}`, textAlign: 'center' }}>
          <div style={{ fontSize: 36, fontWeight: 'bold', color: colors.text }}>{total}</div>
          <div style={{ color: colors.textMuted, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 }}>Total gagné</div>
        </div>
      </div>

      {/* How to earn */}
      <div style={{ background: colors.card, borderRadius: radius.md, padding: 20, border: `1px solid ${colors.border}`, marginBottom: 24 }}>
        <h3 style={{ color: colors.text, fontSize: 16, marginBottom: 12 }}>Comment gagner des points</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span>👤</span><span style={{ color: colors.textMuted, fontSize: 13 }}>Profil complété: <strong style={{ color: colors.gold }}>100 pts</strong></span></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span>🛍️</span><span style={{ color: colors.textMuted, fontSize: 13 }}>1€ dépensé: <strong style={{ color: colors.gold }}>1 pt</strong></span></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span>🤝</span><span style={{ color: colors.textMuted, fontSize: 13 }}>Parrainage: <strong style={{ color: colors.gold }}>50 pts</strong></span></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span>💬</span><span style={{ color: colors.textMuted, fontSize: 13 }}>Social: <strong style={{ color: colors.gold }}>10 pts</strong></span></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span>🏆</span><span style={{ color: colors.textMuted, fontSize: 13 }}>Concours gagné: <strong style={{ color: colors.gold }}>200 pts</strong></span></div>
        </div>
      </div>

      {/* Last Bill */}
      {lastBill && (
        <div style={{ background: colors.card, borderRadius: radius.md, padding: 20, border: `1px solid ${colors.gold}30`, marginBottom: 24 }}>
          <h3 style={{ color: colors.gold, fontSize: 16, marginBottom: 12 }}>Dernière addition</h3>
          {lastBill.items?.map((item: any, i: number) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: `1px solid ${colors.border}` }}>
              <span style={{ color: colors.text }}>{item.product_name} × {item.quantity}</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12, fontWeight: 'bold' }}>
            <span style={{ color: colors.textMuted }}>Total</span>
            <span style={{ color: colors.gold, fontSize: 18 }}>{lastBill.total_amount}€</span>
          </div>
        </div>
      )}

      {/* Transactions */}
      <div style={{ background: colors.card, borderRadius: radius.md, padding: 20, border: `1px solid ${colors.border}` }}>
        <h3 style={{ color: colors.text, fontSize: 16, marginBottom: 12 }}>Historique des points</h3>
        {transactions.length === 0 ? (
          <p style={{ color: colors.textMuted, textAlign: 'center' }}>Aucun point gagné</p>
        ) : (
          transactions.map((t: any) => {
            const info = reasons[t.reason] || { emoji: '⭐', label: t.reason };
            return (
              <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${colors.border}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 20 }}>{info.emoji}</span>
                  <div>
                    <div style={{ color: colors.text, fontSize: 14 }}>{info.label}</div>
                    <div style={{ color: colors.textMuted, fontSize: 12 }}>{new Date(t.created_at).toLocaleDateString('fr-FR')}</div>
                  </div>
                </div>
                <span style={{ color: t.points > 0 ? colors.success : colors.error, fontWeight: 'bold' }}>
                  +{t.points} pts
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}